import {
  CREATE_UNIT_OF_MEASUREMENT_SUCCESS,
  FETCH_UNIT_OF_MEASUREMENT_SUCCESS,
  GET_UNIT_OF_MEASUREMENT_SUCCESS,
  SAVE_UNIT_OF_MEASUREMENT_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_UNIT_OF_MEASUREMENT_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_UNIT_OF_MEASUREMENT_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_UNIT_OF_MEASUREMENT_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_UNIT_OF_MEASUREMENT_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
